const faceCache = new Map<number, string>();

export function getDiceFaceDataUrl(value: number): string {
  const cached = faceCache.get(value);
  if (cached) return cached;

  const size = 128;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Canvas 2D context unavailable');
  }

  ctx.fillStyle = '#f8f4ea';
  ctx.fillRect(0, 0, size, size);
  ctx.strokeStyle = '#2a1810';
  ctx.lineWidth = 6;
  ctx.strokeRect(8, 8, size - 16, size - 16);

  ctx.fillStyle = '#1a1208';
  ctx.font = 'bold 72px Pretendard, system-ui, sans-serif';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(String(value), size / 2, size / 2 + 4);

  const dataUrl = canvas.toDataURL('image/png');
  faceCache.set(value, dataUrl);
  return dataUrl;
}
